export default __webpack_public_path__ + "static/media/mindmap_parkinson.0705504e.png";